import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './components/Login';
import AdminLayout from './components/AdminLayout';

function App() {
  // Au chargement, on vérifie si l'utilisateur est déjà connecté
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('adminLoggedIn'));

  const handleLogin = () => {
    // On sauvegarde l'état de connexion
    localStorage.setItem('adminLoggedIn', 'true');
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    // On supprime l'état de connexion
    localStorage.removeItem('adminLoggedIn');
    setIsLoggedIn(false);
  };

  return (
    <Router>
        <Routes>
          <Route path="/login" element={!isLoggedIn ? <Login onLogin={handleLogin} /> : <Navigate to="/" />} />
          <Route path="/*" element={isLoggedIn ? <AdminLayout handleLogout={handleLogout} /> : <Navigate to="/login" />} />
        </Routes>
    </Router>
  );
}

export default App;
